import { render, staticRenderFns } from "./AlertArea.vue?vue&type=template&id=1d62d49e"
import script from "./AlertArea.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertArea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports